import { FormLayoutTheme, multiVariantStyles, variants } from '../FormLayoutStyles.css';
import { baseTheme } from './FormLayoutBaseTheme.css';

const FormLayoutRedwoodTheme: FormLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { FormLayoutRedwoodTheme };
